import Layout from '@/layout';
import exchangeShop from './exchangeShop';

export default [
  {
    path: '/income',
    name: 'Income',
    redirect: '/income/data',
    component: Layout,
    meta: {
      title: '收益管理',
      icon: 'icon-income',
    },
    children: [
      {
        path: 'data',
        name: 'IncomeData',
        component: () => import('@/views/income/Data'),
        meta: {
          title: '收益数据',
          backToHome: true,
          pageTitle: '收益总览',
          showSideBar: true,
        },
      },
      {
        path: 'settlement',
        name: 'IncomeSettlement',
        component: () => import('@/views/income/Settlement'),
        meta: {
          title: '个人结算中心',
          backToHome: true,
          pageTitle: '结算中心',
          showSideBar: true,
        },
      },
      {
        path: 'dataDetail',
        name: 'dataDetail',
        component: () => import('@/views/income/dataDetail'),
        meta: {
          title: '账单详情',
          activePath: 'data',
          pageTitle: '收益数据',
        },
        hidden: true,
      },
      {
        path: 'settlementDetail',
        name: 'settlementDetail',
        component: () => import('@/views/income/settlementDetail'),
        meta: {
          title: '提现记录',
          activePath: 'settlement',
          pageTitle: '提现记录',
        },
        hidden: true,
      },
      {
        path: 'withdrawDetail',
        name: 'withdrawDetail',
        component: () =>
          import('@/views/income/components/withdraw/detail.vue'),
        meta: {
          title: '提现详情',
          activePath: 'settlement',
          pageTitle: '提现详情',
        },
        hidden: true,
      },
      {
        path: 'detail/withdrawForm',
        name: 'withdrawForm',
        component: () => import('@/views/income/components/withdraw/form.vue'),
        meta: {
          title: '提现表单',
          activePath: 'settlement',
          pageTitle: '提现申请',
        },
        hidden: true,
      },
      {
        path: 'settlementSet',
        name: 'settlementSet',
        component: () => import('@/views/income/settlementSet'),
        meta: {
          title: '结算设置',
          activePath: 'settlement',
          pageTitle: '银行卡绑定',
        },
        hidden: true,
        children: [
          {
            path: 'bindForm',
            name: 'bindForm',
            component: () =>
              import('@/views/income/components/resultSet/bindForm'),
            meta: {
              title: '绑定银行卡',
              activePath: 'settlement',
              pageTitle: '银行卡绑定',
            },
            hidden: true,
          },
          {
            path: 'bindInfo',
            name: 'bindInfo',
            component: () =>
              import('@/views/income/components/resultSet/bindInfo.vue'),
            meta: {
              title: '绑定信息',
              activePath: 'settlement',
              pageTitle: '银行卡信息',
            },
            hidden: true,
          },
        ],
      },
      exchangeShop[0].children[0],
    ],
  },
];
